import {SampleGroupResponse} from 'samples/sample-groups/SampleGroupConstants';
import * as net from 'util/Net';

import {ImportedRow} from './makeSampleGroup';

interface FetchSampleGroupsResponse extends SampleGroupResponse {
  sampleGroupIdsByRequestId: {[requestId: string]: Array<string>};
}

export function fetchSampleGroups({
  requestIds,
}: {
  requestIds: Array<string>;
}): Promise<FetchSampleGroupsResponse> {
  return net.postJSONPromise({
    url: '/1/api/requests/sample-groups',
    data: {
      requestIds,
    },
  });
}

interface GetNewSampleGroupsFromGridResponse {
  importedRows: Array<ImportedRow>;
}

export function getNewSampleGroupsFromGrid({
  gridId,
  sampleGroupSchemaId,
}: {
  gridId: string;
  sampleGroupSchemaId: string;
}): Promise<GetNewSampleGroupsFromGridResponse> {
  return net.getJSONPromise('/1/api/sample-groups:get-new-sample-groups-from-grid', {
    gridId,
    sampleGroupSchemaId,
  });
}
